import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BreadcrumbModule} from '../../components/breadcrumb/breadcrumb.module';
import {SharedModule} from 'src/app/shared/shared.module';
import {TenantSolutionsComponent} from './tenant-solutions.component';
import {TenantSolutionsRoutingModule} from './tenant-solutions-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { ClipboardModule } from 'ngx-clipboard';
import { ErrorDialogModule } from 'src/app/components/error-dialog/error-dialog.module';
import { ErrorModule } from 'src/app/components/error/error.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { PlayButtonModule } from 'src/app/components/play-button/play-button.module';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { SidenavHeaderModule } from 'src/app/components/sidenav-header/sidenav-header.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import { TableModule } from 'src/app/table/table.module';
import { SolutionVersionsComponent } from './solution-versions/solution-versions.component';
import { SolutionVersionDetailsComponent } from './solution-version-details/solution-version-details.component';
import { ExternalPackageComponent } from './external-package/external-package.component';
import { SidenavCapabilityComponent } from './sidenav-capability/sidenav-capability.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SidenavCustomImageComponent } from '../sidenav-custom-image/sidenav-custom-image.component';

@NgModule({
  declarations: [
    TenantSolutionsComponent,
    SolutionVersionsComponent,
    SolutionVersionDetailsComponent,
    ExternalPackageComponent,
    SidenavCapabilityComponent,
    SidenavCustomImageComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BreadcrumbModule,
    TenantSolutionsRoutingModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCardModule,
    PaginatorModule,
    PlayButtonModule,
    IconsModule,
    TableModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    SidenavHeaderModule,
    ToolbarModule,
    ReactiveFormsModule,
    FormsModule,
    ErrorModule,
    MatSlideToggleModule,
    ClipboardModule,
    MatSortModule,
    MatSelectModule,
    ErrorDialogModule,
    SearchFilterModule,
    NgxSkeletonLoaderModule
  ]
})
export class TenantsSolutionsModule {
}
